export const TPA_EXPERIMENTS = {
  INSTALL_ECOM: 'specs.membership.InstallEcom',
  BREAKPOINT_INDICATORS_OOI: 'specs.membership.breakpointIndicatorsOOI',
  SUGGEST_ECOM_MIGRATION: 'specs.pricingPlans.SuggestEcomMigration',
  IMPROVE_ECOM_LOADING_STATE: 'specs.PricingPlans.ImproveEcomLoadingState',
  CASHIER_COUPON_DISCOUNT: 'specs.pricingPlans.CashierCouponDiscount',
  FONT_SIZE_FOR_TPA_ELEMENTS: 'specs.membership.FontSizeForTPAElements',
  ALLOW_CHECKOUT_IN_EDITOR_PREVIEW: 'specs.pricingPlans.AllowCheckoutInEditorPreview',
  ENABLE_VARIANTS: 'pricingPlansMultiplePricingVariants',
  ENABLE_VARIANTS_VIEWER: 'pricingPlansMultiplePricingVariantsViewer',
  ENABLE_ROUTER_URI_CONFLICT_MESSAGE: 'pricingPlansEnableRouterUriConflictMessage',
  ADDONS_NON_BLOCKS_WIDGETS: 'specs.pricingPlans.AddonsNonBlocksWidgets',
  MIGRATE_THUMBNAILS_TO_WDS: 'pricingPlansMigrateThumbnailsToWDS',
  PRESELECT_PLAN_LIST_PLANS: 'pricingPlansPreselectPlanListPlans',
  NOT_SEND_DISCRIMINATOR: 'pricingPlansNotSendDiscriminator',
  RESET_CTA_LOADER_ON_BFCACHE: 'pricingPlansResetCtaLoaderOnBfcache'
};
//# sourceMappingURL=tpa.js.map